import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=156fce6e&"
import script from "./mall.vue?vue&type=script&lang=js&"
export * from "./mall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports